import { ActionConfirmDialog } from '../../../components/common/ActionConfirmDialog';
import { pendingConfirmCopy, type PendingConfirm } from './pendingConfirm';

export type { PendingConfirm };

interface OutreachConfirmDialogProps {
  open: boolean;
  pending: PendingConfirm | null;
  busy: boolean;
  onClose: () => void;
  onConfirm: (reason?: string) => void;
}

/** `pending` outlives `open` so the copy survives the close animation (G1-b). */
export function OutreachConfirmDialog({ open, pending, busy, onClose, onConfirm }: OutreachConfirmDialogProps) {
  const suppress = pending?.kind === 'suppress';
  return (
    <ActionConfirmDialog
      open={open}
      onOpenChange={(o) => {
        if (!o) onClose();
      }}
      {...pendingConfirmCopy(pending)}
      reasonMinLength={suppress ? 0 : undefined}
      reasonLabel={suppress ? 'Why? (optional)' : undefined}
      reasonPlaceholder={suppress ? 'asked us to stop' : undefined}
      hideConfirmIcon
      busy={busy}
      onConfirm={(reason) => onConfirm(reason?.trim() || undefined)}
    />
  );
}
